import { render, staticRenderFns } from "./HelpItemContent.vue?vue&type=template&id=10ae9351&"
import script from "./HelpItemContent.vue?vue&type=script&lang=js&"
export * from "./HelpItemContent.vue?vue&type=script&lang=js&"
import style0 from "./HelpItemContent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ae9351')) {
      api.createRecord('10ae9351', component.options)
    } else {
      api.reload('10ae9351', component.options)
    }
    module.hot.accept("./HelpItemContent.vue?vue&type=template&id=10ae9351&", function () {
      api.rerender('10ae9351', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/HelpItemContent.vue"
export default component.exports